<template>
  <div>
    <panel
      :title="$t('homePage.changePassword')"
      variant="default"
      noButton="true"
    >
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fas fa-key"></i>
            </span>
          </div>
          <input
            v-model="model.current_password"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': errors.has('current_password') }"
            :placeholder="$t('homePage.currentPassword')"
          />
        </div>
        <div class="validate" v-if="errors.has('current_password')">
          {{ errors.first('current_password') }}
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fas fa-unlock-alt"></i>
            </span>
          </div>
          <input
            v-model="model.new_password"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': errors.has('new_password') }"
            :placeholder="$t('homePage.newPassword')"
          />
        </div>
        <div class="validate" v-if="errors.has('new_password')">
          {{ errors.first('new_password') }}
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fas fa-lock"></i>
            </span>
          </div>
          <input
            v-model="model.confirm_password"
            type="password"
            class="form-control"
            :class="{ 'is-invalid': errors.has('confirm_password') }"
            :placeholder="$t('homePage.confirmPassword')"
          />
        </div>
        <div class="validate" v-if="errors.has('confirm_password')">
          {{ errors.first('confirm_password') }}
        </div>
      </div>
      <ts-button
        outline
        color="primary"
        class="btn-block"
        :waiting="changing"
        @click.prevent="change"
        >{{ $t('homePage.change') }}</ts-button
      >
    </panel>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'changePassword',
  data() {
    return {
      model: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      changing: false,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('home/staff', ['profile'])
  },
  methods: {
    change() {
      this.errors = new Errors()
      this.changing = true
      this.$store
        .dispatch(
          'home/staff/changePwd',
          Object.assign({}, this.model, { id: this.profile.user_id })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.clear()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.changing = false
        })
    },
    clear() {
      this.model = {
        current_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  }
}
</script>
